import { useEffect } from 'react';
import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { ABNDetail, ApplicantEntityIndex } from '@funnels/types';

import { ABNSearch } from '../Common';

interface ApplicantCompanySearchProps extends ApplicantEntityIndex {
  isDisabledAndUnset?: boolean;
  name: string;
  label: string;
  value?: string;
  isOptional?: boolean;
}

export const ApplicantCompanySearch = ({
  applicantIndex,
  isDisabledAndUnset,
  name,
  label,
  value,
  isOptional,
}: ApplicantCompanySearchProps) => {
  const [formValues, , setFormValues] = useFormValues();

  const abn = get(formValues, FIELD_PATHS.APPLICANT_COMPANY_ABN(applicantIndex));
  const businessName = get(formValues, FIELD_PATHS.APPLICANT_COMPANY_NAME(applicantIndex), '');

  const handleSelectABN = (businessDetails: ABNDetail) => {
    setFormValues({
      [FIELD_PATHS.APPLICANT_COMPANY_ABN(applicantIndex)]: businessDetails.abn,
      [FIELD_PATHS.APPLICANT_COMPANY_NAME(applicantIndex)]: businessDetails.entityName ?? businessName,
    });
  };

  const handleUnsetABN = () => {
    setFormValues({
      [FIELD_PATHS.APPLICANT_COMPANY_ABN(applicantIndex)]: undefined,
    });
  };

  useEffect(() => {
    if (isDisabledAndUnset) {
      handleUnsetABN();
    }
  }, [isDisabledAndUnset]);

  return (
    <ABNSearch
      isOptional={isOptional}
      label={label}
      abn={!!abn ? abn.toString() : ''}
      businessName={businessName}
      onABNSelect={handleSelectABN}
      onABNUnset={handleUnsetABN}
      isDisabled={isDisabledAndUnset}
      fieldPath={name}
      value={value}
      placeholder="Search company name or ABN"
    />
  );
};
